export default "__VITE_ASSET__C74mQZKI__"